import type { QueryErrorsViewProps } from "@/domains/diagnostics/types"
import { Card } from "@/components/card"
import { MessageBox } from "@/domains/common/components/message-box"

export const QueryErrorsView = ({ errors }: QueryErrorsViewProps) => {
  if (errors.length === 0) {
    return null
  }

  return (
    <Card.Container>
      <h3 className="mb-4 text-lg font-semibold text-t100">Query Errors</h3>
      <div className="space-y-4">
        {errors.map((error, index) => (
          <div key={index} className="space-y-2">
            <div className="font-medium text-red-400">{error.queryName}</div>
            <MessageBox variant="error" size="sm">
              <div className="space-y-1">
                <div className="text-sm text-t100">{error.errorMessage}</div>
                <div className="text-xs text-t200">Last occurred: {error.lastOccurred}</div>
              </div>
            </MessageBox>
          </div>
        ))}
      </div>
    </Card.Container>
  )
}
